import React from 'react';
import { Card, CardContent } from "@shared/ui/card";
import { Button } from "@shared/ui/button";
import { cn } from "@shared/lib/utils";

interface ConfigCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  action: string;
  onClick: () => void;
  className?: string;
}

export function ConfigCard({
  icon,
  title,
  description,
  action,
  onClick,
  className
}: ConfigCardProps) {
  return (
    <Card className={cn("hover:shadow-md transition-all", className)}>
      <CardContent className="">
        <div className="flex items-start space-x-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 text-blue-700">
            {icon}
          </div>
          <div className="flex-1">
            <h3 className="text-base font-semibold">{title}</h3>
            <p className="mt-1 text-sm text-muted-foreground pb-4">{description}</p>
            <Button 
              variant="outline" 
              className="" 
              onClick={onClick}
            >
              {action}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}